import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { AiUpsellInEditorFreeModalProps } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyAiUpsellInEditorFreeModal = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-ai-upsell-in-editor-free-modal" */ './AiUpsellInEditorFreeModal.tsx'
		),
	{
		ssr: false,
	},
);

export const AsyncAiUpsellInEditorFreeModal = (
	props: AiUpsellInEditorFreeModalProps,
): React.JSX.Element => (
	<ErrorBoundary
		id="asyncAiUpsellInEditorFreeModal"
		packageName="jira-growth-ai-upsell-in-editor-free-modal"
		teamName="growth-tako"
		render={() => <></>}
	>
		<LazyAiUpsellInEditorFreeModal {...props} />
	</ErrorBoundary>
);
